//loading
export const LOADING_TRUE = "loading/true";

//Error
export const ERROR_TRUE = "error/true";

//login
export const LOG_IN_SUCCESS = "auth/login/success";
export const LOG_OUT_SUCCESS = "auth/logout/success";

//sign In
export const SIGN_UP_SUCCESS = "auth/signup/success";


// // Reset
// export const RESET_AUTH = "auth/reset";
